// extracted by mini-css-extract-plugin
export default {"chartFigure":"Charts_chartFigure__cYM-E","title":"Charts_title__85wCn","chart":"Charts_chart__rdXRi"};